module.exports = "/_next/static/videos/soccer-1-bf5d7bd211ff5287d783081454e3ba16.webm";